"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT_DROPDOWN = exports.SELECT = void 0;
const colors_1 = require("../styles/colors");
exports.SELECT = {
    styleOverrides: {
        standard: {
            '&.MuiInput-input:focus': {
                background: 'none',
            },
            '&:hover': {
                borderBottom: `2px solid ${colors_1.$grey80}`,
                '&.Mui-disabled': {
                    borderBottom: 'none',
                },
            },
        },
        outlined: {
            padding: '8px 0 8px 16px',
            '&.MuiInputBase-inputSizeSmall': {
                padding: '5px 0 4px 16px',
            },
        },
    },
};
exports.SELECT_DROPDOWN = {
    styleOverrides: {
        list: {
            backgroundColor: colors_1.$primaryWhite,
        },
    },
};
